import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Select from '../components/Select'
import Point from '../components/Point'
import jump from '../components/Jump'
import ProjectDetail from '../components/ProjectDetail'
import Author from '../components/Author'
import Policy from '../components/Policy'
import Case from '../components/Case'
import Partake from '../components/Partake'
import Problem from '../components/Problem'
import ServiceDetail from '../components/ServiceDetail'
import RoadShowDetail from '../components/RoadShowDetail'
import special from '../components/Special'
import advantage from '../components/Advantage'


/*混改直播间*/
const LiveDetail = () =>
  import( /* webpackChunkName: "live" */ '@/components/live/LiveDetail')

Vue.use(Router);

const router = new Router({
  linkActiveClass: 'active',
  hashbang: true, // 将路径格式化为#!开头
  history: true, // 启用HTML5 history模式，可以使用pushState和replaceState来管理记录
  /**
   * @desc 路由配置
   */
  routes: [
    {
      path: '/select',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: Select,
    }, {
      path: '/jump',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: jump
    }, {
      path: '/projectDetail',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: ProjectDetail
    }, {
      path: '/point',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: Point
    },
    {
      path: '/roadShowDetail',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: RoadShowDetail
    },
    {
      path: '/live-detail',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: LiveDetail,
    },{
      path: '/author',
      component: Author,
      meta: { title: '国企混改项目信息发布平台',requiresAuth: true }
    },{
      path: '/policy',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: Policy,
    },{
      path: '/case',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: Case,
    },{
      path: '/partake',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: Partake,
    },{
      path: '/problem',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: Problem,
    },{
      path: '/serviceDetail',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: ServiceDetail,
    },{
      path: '/special',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: special,
    },{
      path: '/advantage',
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: advantage,
    },{
      path: '/*',
      redirect:'/select',//路由重定向
      meta: {
        title: '国企混改项目信息发布平台'
      },
      component: Select
    }
  ]
})
/**
 * @desc 全局监听路由变化
 */
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title;//给每个页面设置网页title
  store.dispatch('updateHistoryLength') // 变化时更新路由切换长度
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js